<template>
    <section class="c-choose-quarkino">
        <y-why-choose-us :content="content" />

        <div
            v-if="content"
            class="c-choose-quarkino__action"
        >
            <y-button
                :tag="isLink(content.button_link) ? 'a' : 'router-link'"
                :href="content.button_link"
                :to="content.button_link"
                :content="content.button_title"
                color="primary"
                size="medium"
                flat
                :no-padding="true"
            />
        </div>
    </section>
</template>

<script>

    import YWhyChooseUs from '@modules/home/components/WhyChooseUs/Index';
    import { isLink } from '@/helpers/helpers';

    export default {
        name      : 'ApiMarketWhyQuarkino',
        components: { YWhyChooseUs },
        props     : {
            content: Object,
        },

        /**
         *
         * @inheritDoc
         */
        methods: {
            isLink,
        },
    };
</script>

<style lang="scss" src="./why-quarkino.scss"></style>
